import { render, staticRenderFns } from "./UserOptHis.vue?vue&type=template&id=ac5d744a&"
import script from "./UserOptHis.vue?vue&type=script&lang=js&"
export * from "./UserOptHis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports